import { Gender, RecoveryCodesMethod } from '@extrahorizon/javascript-sdk';
import { UserProfile } from 'utils/models';

export interface PatientLogsVariables {
  groupId?: string;
  profileId?: string;
}

export interface PatientSearchVariables {
  searchValue: string;
}
export interface RegenerateCodesVariables {
  userId?: string;
  password: string;
  callback: (result: RecoveryCodesMethod) => void;
}

export interface UpdatePersonalDataVariables {
  values: UserProfile;
  callback: () => void;
}
export interface EicModel {
  firstName: string;
  lastName: string;
  approvalTimestamp: Date;
  withdrawalTimestamp: Date;
  status: EicStatus;
}

export enum EicStatus {
  Approved = 'approved',
  Withdrawn = 'withdrawn',
}

export interface UpdateCustomFieldsVariables {
  profileId?: string;
  customField?: ProfileCustomFields;
  value: string;
}

export enum ProfileCustomFields {
  PatientId = 'extra_patient_id',
  Physician = 'extra_physician',
}

export const GenderMap = [
  { label: 'male_label', code: Gender.Male },
  { label: 'female_label', code: Gender.Female },
  { label: 'unknown_label', code: Gender.Unknown },
  { label: 'not_applicable_label', code: Gender.NotApplicable },
];
